import { render, staticRenderFns } from "./ComplaintsView.vue?vue&type=template&id=28b2b84d&scoped=true"
import script from "./ComplaintsView.vue?vue&type=script&lang=js"
export * from "./ComplaintsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2b84d",
  null
  
)

export default component.exports